// client/src/components/messages/EmbedRenderer.js
import React from 'react';
import { Card, CardMedia, CardContent, Typography, Box, Chip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import VideogameAssetIcon from '@mui/icons-material/VideogameAsset';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import ExtensionIcon from '@mui/icons-material/Extension';
import MovieIcon from '@mui/icons-material/Movie';
import MusicNoteIcon from '@mui/icons-material/MusicNote';

const EmbedRenderer = ({ embeds }) => {
  const navigate = useNavigate();

  if (!embeds || embeds.length === 0) return null;

  const getIcon = (type) => {
    switch (type) {
      case 'game': return <VideogameAssetIcon fontSize="small" />;
      case 'console': return <SportsEsportsIcon fontSize="small" />;
      case 'lego': return <ExtensionIcon fontSize="small" />;
      case 'movie': return <MovieIcon fontSize="small" />;
      case 'music': return <MusicNoteIcon fontSize="small" />;
      default: return null;
    }
  };

  const getTypeLabel = (type) => {
    return type.charAt(0).toUpperCase() + type.slice(1);
  };

  const handleClick = (embed) => {
    // Navigate to the appropriate collection page
    const routes = {
      game: '/games',
      console: '/consoles',
      lego: '/lego',
      movie: '/movies',
      music: '/music'
    };
    navigate(routes[embed.type] || '/dashboard');
  };

  return (
    <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
      {embeds.map((embed, idx) => (
        <Card 
          key={idx} 
          sx={{ 
            maxWidth: 400, 
            cursor: 'pointer',
            '&:hover': { boxShadow: 3 }
          }}
          onClick={() => handleClick(embed)}
        >
          <Box sx={{ display: 'flex' }}>
            {embed.imageUrl && (
              <CardMedia
                component="img"
                sx={{ width: 120, height: 120, objectFit: 'cover' }}
                image={embed.imageUrl}
                alt={embed.title}
              />
            )}
            <CardContent sx={{ flex: 1, p: 1.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
                <Chip 
                  icon={getIcon(embed.type)}
                  label={getTypeLabel(embed.type)}
                  size="small"
                  color="primary"
                  variant="outlined"
                />
              </Box>
              <Typography variant="subtitle2" component="div" sx={{ fontWeight: 'bold' }}>
                {embed.title}
              </Typography>
              {embed.metadata && (
                <Box sx={{ mt: 0.5 }}>
                  {embed.metadata.platform && (
                    <Typography variant="caption" color="text.secondary" display="block">
                      {embed.metadata.platform}
                    </Typography>
                  )}
                  {embed.metadata.year && (
                    <Typography variant="caption" color="text.secondary" display="block">
                      {embed.metadata.year}
                    </Typography>
                  )}
                  {embed.metadata.setNumber && (
                    <Typography variant="caption" color="text.secondary" display="block">
                      Set #{embed.metadata.setNumber}
                    </Typography>
                  )}
                </Box>
              )}
            </CardContent>
          </Box>
        </Card>
      ))}
    </Box>
  );
};

export default EmbedRenderer;
